import React from 'react';
import { ReactComponent as AddIcon } from "Icons/new-plus.svg";
import { ReactComponent as DeleteIcon } from "Icons/delete.svg";
import Input from 'Components/Input';
import Dropdown from 'Components/Dropdown/dropdown';
import Cx from 'classnames';

const VARIABLE_COST_TRIP = [
    {name: 'ONE_WAY', value: 1},
    {name: 'TWO_WAY', value: 2}
]


const dplDedicatedContract = (props) => {
    const { onChangeTrips, isView, onChangeDedicatedVC, trip, tripIndex, pricingBasis } = props;

    return (
        <>
            <div className={Cx('', {
                'disable-pointer-events': isView
            })}> 
                {/* <ResponsiveTable> */}
                    <div className='flex col-1'>
                        <div className='content-bgColor pv-5 ph-10 mt-5 br-2 mr-20 inBlock col-1'>
                            <table className='trip-table-secondary' cellspacing={'10px'}>
                                <tr>
                                    <th>Fixed Cost <span style={{ color: 'red' }}>*</span></th>
                                    <th>Fixed Cost UOM <span style={{ color: 'red' }}>*</span></th>
                                    <th>Variable Cost <span style={{ color: 'red' }}>*</span></th>
                                    <th>Variable Cost UOM <span style={{ color: 'red' }}>*</span></th>
                                    <th>Variable Cost Trip <span style={{ color: 'red' }}>*</span></th>
                                </tr>
                                <tr>
                                    <td>
                                        <Input 
                                            className={'border-dblue br-2 wt-200'}
                                            placeholder={'Fixed Cost'}                                            
                                            value={trip.fixed_price}
                                            onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}
                                            onChange={(e) => onChangeTrips(tripIndex, 'fixed_price', e)}
                                            type={'number'}
                                        />
                                    </td>
                                    <td className={Cx('', {'disable-pointer-events': isView})}>
                                        <div className='flex'>
                                            <Dropdown 
                                                items={pricingBasis}
                                                displayKey={"name"}
                                                widthValue={'250px'}
                                                className="border-dblue bg-white"
                                                name="fixed_price_uom" 
                                                label="Select"
                                                selectedItem={trip.fixed_price_uom_id && pricingBasis.find(el => el.value == trip.fixed_price_uom_id)}
                                                onSelect={(optionValue) => onChangeTrips(tripIndex, 'fixed_price_uom', pricingBasis.find(el => el.name == optionValue))}
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <Input 
                                            className={'border-dblue br-2 wt-200'}
                                            placeholder={'Variable Cost'}                                            
                                            value={trip.variable_cost}
                                            onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}
                                            onChange={(e) => onChangeTrips(tripIndex, 'variable_cost', e)}
                                            type={'number'}
                                        />
                                    </td>
                                    <td className={Cx('', {'disable-pointer-events': isView})}>
                                        <div className='flex'>
                                            <Dropdown 
                                                items={pricingBasis}
                                                displayKey={"name"}
                                                widthValue={'250px'}
                                                className="border-dblue bg-white"
                                                name="variable_cost_uom" 
                                                label="Select"
                                                selectedItem={trip.variable_cost_uom_id && pricingBasis.find(el => el.value == trip.variable_cost_uom_id)}
                                                onSelect={(optionValue) => onChangeTrips(tripIndex, 'variable_cost_uom', pricingBasis.find(el => el.name == optionValue))}
                                            />
                                        </div>
                                    </td>
                                    <td className={Cx('', {'disable-pointer-events': isView})}>
                                        <div className='flex'>
                                            <Dropdown 
                                                items={VARIABLE_COST_TRIP}
                                                displayKey={"name"}
                                                widthValue={'250px'}
                                                className="border-dblue bg-white"
                                                name="trip_type_name" 
                                                label="Select"
                                                selectedItem={trip.trip_type_name && VARIABLE_COST_TRIP.find(el => el.name == trip.trip_type_name)}
                                                onSelect={(optionValue) => onChangeTrips(tripIndex, 'trip_type_name', VARIABLE_COST_TRIP.find(el => el.name == optionValue))}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    
                        {/* <div className='content-bgColor pv-5 ph-10 mt-5 br-2 mr-10 inBlock col-2'>
                            <table className='trip-table-secondary' cellspacing={'10px'}>
                                <tr>
                                    <th>Variable Cost <span style={{ color: 'red' }}>*</span></th>
                                    <th>Variable Cost UOM <span style={{ color: 'red' }}>*</span></th>
                                    <th>Variable Cost Trip <span style={{ color: 'red' }}>*</span></th>
                                    {!isView && <th></th>}
                                </tr>
                                {(trip.dedicated_variable_cost || []).map((dedicatedCost, dedicatedIndex) => {

                                    return(<tr>

                                            <td className={Cx('', {'disable-pointer-events': isView})}>
                                                <Input 
                                                    className={'border-dblue br-2 wt-150'}
                                                    type={'number'}
                                                    placeholder={'Variable Cost'}
                                                    onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}
                                                    value={dedicatedCost.variable_cost}
                                                    onChange={(e) => onChangeDedicatedVC(tripIndex, 'variable_cost', e, dedicatedIndex)}
                                                />
                                            </td>
                                            <td className={Cx('', {'disable-pointer-events': isView})}>
                                                <Dropdown 
                                                    items={pricingBasis}
                                                    displayKey={"name"}
                                                    widthValue={'200px'}
                                                    className="border-dblue bg-white"
                                                    name="pricing_basis" 
                                                    label="Select"
                                                    selectedItem={dedicatedCost.pricing_basis && pricingBasis.find(el => el.name == dedicatedCost.pricing_basis)}
                                                    onSelect={(optionValue) => onChangeDedicatedVC(tripIndex, 'pricing_basis', pricingBasis.find(el => el.name == optionValue), dedicatedIndex)}
                                                />
                                            </td>
                                            <td className={Cx('', {'disable-pointer-events': isView})}>
                                                <Dropdown 
                                                    items={VARIABLE_COST_TRIP}
                                                    displayKey={"name"}
                                                    widthValue={'150px'}
                                                    className="border-dblue bg-white"
                                                    name="variable_cost_trip" 
                                                    label="Select"
                                                    selectedItem={dedicatedCost.variable_cost_trip && VARIABLE_COST_TRIP.find(el => el.name == dedicatedCost.variable_cost_trip)}
                                                    onSelect={(optionValue) => onChangeDedicatedVC(tripIndex, 'variable_cost_trip', VARIABLE_COST_TRIP.find(el => el.name == optionValue), dedicatedIndex)}
                                                />
                                            </td>
                                            {!isView &&<td>
                                                <div className='flex'>
                                                    {(trip.dedicated_variable_cost || []).length > 1 && <DeleteIcon className='wt-18 ht-18 mr-5 curP fBold' onClick={() => props.onDeleteDedicatedVC(tripIndex, dedicatedIndex)}/>}
                                                    <AddIcon className='curP' onClick={() => props.onAddDedicatedVC(tripIndex)}/>
                                                </div>
                                            </td>}
                                    </tr>)
                                })}
                            </table>
                        </div> */}
                    </div>
                {/* </ResponsiveTable> */}
            </div>
        </>
    )
}

export default dplDedicatedContract;
